
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/doe-dagen/[slug]",
      function () {
        return require("private-next-pages/doe-dagen/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/doe-dagen/[slug]"])
      });
    }
  